import React from 'react';

import { MessagesSquare } from 'lucide-react';

import { type GetIdeaActivityResponse, IdeaActivityType } from 'common/api/endpoints/ideaActivity';
import LoadMore from 'common/common/LoadMore';
import VStack from 'common/ui/VStack';
import Empty from 'common/uiV3/Empty';

import IdeaComment from './IdeaComment';

import type { QueryParams as IdeaActivityQueryParams } from 'common/actions/ideaActivityQueries';
import type { Idea } from 'common/api/endpoints/idea';

type IdeaActivityProps = {
  activityQueryParams: IdeaActivityQueryParams;
  hasNextPage: boolean;
  idea: Idea;
  ideaActivity: GetIdeaActivityResponse | undefined;
  loadingMore: boolean;
  onLoadMore: () => void;
};

const ActivityList = ({
  activityQueryParams,
  hasNextPage,
  idea,
  ideaActivity,
  loadingMore,
  onLoadMore,
}: IdeaActivityProps) => {
  if (!ideaActivity || ideaActivity.items.length === 0) {
    return (
      <Empty>
        <Empty.Header>
          <Empty.Media variant="icon">
            <MessagesSquare />
          </Empty.Media>
          <Empty.Title>No comments found</Empty.Title>
          <Empty.Description>There are no comments or logs for this idea.</Empty.Description>
        </Empty.Header>
      </Empty>
    );
  }

  return (
    <VStack className="gap-4">
      {ideaActivity.items.map((activity) => {
        if (activity.type === IdeaActivityType.comment) {
          return (
            <IdeaComment
              key={activity._id}
              idea={idea}
              comment={activity.comment}
              activityQueryParams={activityQueryParams}
            />
          );
        }

        // TODO: Add support for other activity types
        return null;
      })}
      <LoadMore hasMore={hasNextPage} loadingMore={loadingMore} onLoadMore={onLoadMore} />
    </VStack>
  );
};

export default ActivityList;
